export default __webpack_public_path__ + "static/media/rooster.46b8c8a2.mp3";